import { AutoComplete, Input, message } from "antd";
import axios from "axios";
import { useState } from "react";
import { useMapboxContext } from "../context/mapbox-context";

const MapboxSearch = () => {
  const { setCoordinates } = useMapboxContext();
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const accessToken = 'pk.eyJ1IjoibGFnYXJzb2Z0IiwiYSI6ImNsajh4a3owNDB0cWMzZW5xOG55Nml3NzkifQ.wsKGApOwDpcS15lme4MB0g'

  const geocodeAddress = async (address: string) => {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${accessToken}`
  
    try {
      const response = await axios.get(url);
      const results = response.data.features;
  
      if (results.length > 0) {
        const firstResult = results[0];
        const coordinates = firstResult.geometry.coordinates;
        const lng = coordinates[0];
        const lat = coordinates[1];
  
        setCoordinates({lng: lng, lat: lat })
  
      } else {
        message.error('No results found')
      }
    } catch (error) {
      console.error('Error getting coordinates:', error);
    }
  };

  const handleSearch = async (value: string) => {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(value)}.json?access_token=${accessToken}&autocomplete=true`;

    try {
      const response = await axios.get(url);
      const results = response.data.features;

      if (results.length > 0) {
        
        const suggestions = results.map((result: any) => result.place_name);
        setSuggestions(suggestions);
      } else {
        setSuggestions([value]);
      }
    } catch (error) {
      console.error('Error trying to get suggestions:', error);
      setSuggestions([]);
    }
  };

  const handleSelect = (value: string) => {
    geocodeAddress(value);
  };

  return (
    <AutoComplete
      options={suggestions.map((suggestion) => ({ value: suggestion }))}
      onSelect={handleSelect}
      onSearch={handleSearch}
      style={{ width: "100%", padding:"5px" }}
    >
      <Input.Search placeholder="Search" style={{ width: "100%" }} onSearch={(value)=>geocodeAddress(value)} />
    </AutoComplete>
  );
};

export default MapboxSearch;
